export default "__VITE_ASSET__BcbcbkcV__"